<ng-container *transloco="let t">
  @if (service.newVersionAvailable()) {
    <div class="new-version-banner" role="status" aria-live="polite">
      <span class="new-version-banner__message">{{ t('New version available') }}</span>
      <button type="button" class="new-version-banner__button" (click)="reload()">
        {{ t('Reload now') }}
      </button>
    </div>
  }
</ng-container>
